/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {

  const checkSkioLoggedIn = () => {
    if (window.Shopify && window.Shopify.designMode) return;

    var skioLoggedIn = false;
    try {
      skioLoggedIn = !!window.localStorage.getItem('storefrontUserId');
    } catch (storageError) {}

    if (!skioLoggedIn) return;

    var applyClass = function () {
      if (document.body) {
        document.body.classList.add('customer-logged-in');
      }
    };

    if (document.body) {
      applyClass();
    } else {
      document.addEventListener('DOMContentLoaded', applyClass);
    }
  };

  checkSkioLoggedIn();


  const initProgressScript = () => {
    const items = document.querySelectorAll(".progressblock");
    const lineToDraw = document.querySelector(".draw-line");
    const progressBox = document.querySelector(".process-progress-box");
    const container = document.querySelector(".progress_container");

    if (!lineToDraw || !progressBox || !container || items.length === 0) return;

    function updateProgressLine() {
      const winWidth = window.innerWidth;
      const scrollY = window.scrollY;
      const viewportHeight = window.innerHeight;
      const boxRect = progressBox.getBoundingClientRect();
      const boxTop = boxRect.top + scrollY;
      const startThreshold = boxTop - viewportHeight / 2;

      items.forEach(item => item.classList.remove("in-view"));

      if (scrollY >= startThreshold) {
        const drawHeight = scrollY - boxTop + viewportHeight / 2.7;
        const drawHeightMobile = scrollY - boxTop - viewportHeight / 2.7 + 450;

        let heightToSet = winWidth <= 767 ? drawHeightMobile : drawHeight;
        heightToSet = Math.max(0, heightToSet);
        lineToDraw.style.height = `${heightToSet}px`;

        const currentLineBottom = lineToDraw.getBoundingClientRect().top + scrollY + heightToSet;

        items.forEach(item => {
          const itemTop = item.getBoundingClientRect().top + scrollY;
          const offsetPadding = winWidth <= 767 ? 30 : 15;

          if (currentLineBottom >= itemTop + offsetPadding) {
            console.log("scrolling");
            item.classList.add("in-view");
            Array.from(item.parentNode.children).forEach(sibling => {
              if (sibling !== item) sibling.classList.remove("in-view");
            });
          } else {
            item.classList.remove("in-view");
          }
        });

        if (heightToSet <= 0) {
          items.forEach(item => item.classList.remove("in-view"));
        }
      }
    }

    let ticking = false;
    function onScrollOrResize() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          updateProgressLine();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", () => setTimeout(updateProgressLine, 200));
    window.addEventListener("orientationchange", () => setTimeout(updateProgressLine, 300));

    // Fallback rechecks to capture async layout shifts
    const initDelays = [100, 300, 600, 1000, 2000, 3000];
    initDelays.forEach(delay => setTimeout(updateProgressLine, delay));
  };

  // Run when DOM ready
  if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(initProgressScript, 100);
  } else {
    document.addEventListener("DOMContentLoaded", initProgressScript);
  }

  // Optional: Re-run if part of SPA or router change
  window.addEventListener("pageshow", () => setTimeout(initProgressScript, 300));
})();

// Helper functions to animate accordion height
function openContent(el) {
  el.style.display = 'block';
  el.style.height = '0px';
  const target = el.scrollHeight + 'px';

  requestAnimationFrame(() => {
    el.style.height = target;
  });
  
  const onEnd = (e) => {
    if (e.propertyName !== 'height') return;
    el.style.height = 'auto';
    el.removeEventListener('transitionend', onEnd);
  };
  el.addEventListener('transitionend', onEnd);
}

function closeContent(el) {
  const current = el.scrollHeight;

  el.style.height = current + 'px';

  void el.offsetHeight;
  el.style.height = '0px';
}

function isOpen(el) {
  const h = getComputedStyle(el).height;

  return parseFloat(h) > 0;
}

function ensureFirstAccordionOpen(root) {
  const container = root || document;
  const groups = Array.from(container.querySelectorAll('.accordion'));
  if (!groups.length) return;

  groups.forEach(group => {
    const blocks = Array.from(group.querySelectorAll('.acc-content-block'));
    if (!blocks.length) return;

    const hasActive = blocks.some(block => block.querySelector('.acc-content')?.classList.contains('active'));
    if (hasActive) return;

    const firstBlock = blocks[0];
    const firstContent = firstBlock.querySelector('.acc-content');
    if (!firstContent) return;

    firstBlock.classList.add('tab-active');
    firstContent.classList.add('active');
    firstContent.style.height = 'auto';
  });
}

function initAccordion(root) {
  const container = root || document;
  const blocks = Array.from(container.querySelectorAll('.acc-content-block'));
  if (!blocks.length) return;

  blocks.forEach((block) => {
    if (block.dataset.accInitialized === 'true') return;
    block.dataset.accInitialized = 'true';

    const content = block.querySelector('.acc-content');
    if (!content) return;

    if (content.classList.contains('active')) {
      block.classList.add('tab-active');
      content.style.height = 'auto';
    } else {
      content.style.height = '0px';
    }
  });

  ensureFirstAccordionOpen(container);
}

function onAccordionTitleClick(event) {
  const title = event.target.closest('.acc-content-block .acc-title');
  if (!title) return;

  const block = title.closest('.acc-content-block');
  const content = block?.querySelector('.acc-content');
  if (!block || !content) return;

  document.querySelectorAll('.acc-content-block').forEach((other) => {
    if (other !== block) {
      other.classList.remove('tab-active');
      const otherContent = other.querySelector('.acc-content');
      if (otherContent && isOpen(otherContent)) {
        otherContent.classList.remove('active');
        closeContent(otherContent);
      }
    }
  });

  if (!isOpen(content)) {
    block.classList.add('tab-active');
    content.classList.add('active');
    openContent(content);
  }
}

document.addEventListener('click', onAccordionTitleClick);
document.addEventListener('DOMContentLoaded', () => {
  initAccordion(document);
  requestAnimationFrame(() => ensureFirstAccordionOpen(document));
  setTimeout(() => ensureFirstAccordionOpen(document), 300);
});
window.addEventListener('load', () => {
  initAccordion(document);
  ensureFirstAccordionOpen(document);
  setTimeout(() => ensureFirstAccordionOpen(document), 300);
});
document.addEventListener('shopify:section:load', (event) => {
  const target = event?.target || document;
  initAccordion(target);
  requestAnimationFrame(() => ensureFirstAccordionOpen(target));
  setTimeout(() => ensureFirstAccordionOpen(target), 300);
});

document.addEventListener("DOMContentLoaded", function () {
  var new_slider_image_text = new Swiper(".content-image-slider", {
    slidesPerView: 1,
    loop: true,
    autoHeight: true,
    navigation: {
      nextEl: ".content-button-next",
      prevEl: ".content-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 1.3,
        spaceBetween: 0,
      },
    },
  });

  // How Graymatter Works
  var bright_mySwiper = new Swiper(".bright-slider", {
    spaceBetween: 20,
    slidesPerView: 3.2, 
    centeredSlides: false,
    roundLengths: true,
    loop: true,
    navigation: {
      nextEl: ".bright-section .swiper-button-next",
      prevEl: ".bright-section .swiper-button-prev",
    },
    pagination: {
      el: ".slider-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      1300: {
        slidesPerView: 3.2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 2.2,
        spaceBetween: 20,
      },
      280: {
        slidesPerView: 1.2,
        spaceBetween: 46,
      },
    },
  });

  const mainSliderElement = document.querySelector('.main-slider');
  if (mainSliderElement) {
    const main_slider = new Swiper(".main-slider", {
      loop: true,
      slidesPerView: 3,
      spaceBetween: 20,
      pagination: {
        el: ".slider-swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        1028: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        576: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
      },
    });

    let mainSliderResizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(mainSliderResizeTimer);
      mainSliderResizeTimer = setTimeout(function () {
        if (main_slider && typeof main_slider.update === "function") {
          main_slider.update();
        }
      }, 200);
    });
  }
});

(function () {
  /* Product Page Accordion — init immediately (custom.js loads async; DOMContentLoaded may already have fired) */
  if (window.__productAccordionInit) return;
  window.__productAccordionInit = true;

  document.addEventListener("click", function (event) {
    const target = event.target;
    if (!target || typeof target.closest !== "function") return;

    const trigger = target.closest(".js-acc-single-trigger");
    if (!trigger) return;

    const thisItem = trigger.closest(".js-acc-item");
    if (!thisItem) return;

    document.querySelectorAll(".js-acc-item").forEach(function (item) {
      if (item === thisItem) {
        item.classList.toggle("is-open");
      } else {
        item.classList.remove("is-open");
      }
    });
  });
})();

function initializeSellingSlider() {
  const existingSlider = document.querySelector(".selling_slider");
  if (!existingSlider) return;

  // Destroy previous instance if exists
  if (existingSlider.swiper) {
    existingSlider.swiper.destroy(true, true);
  }

  // Initialize new Swiper
  new Swiper(".selling_slider", {
    loop: true,
    slidesPerView: 3,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next-unique",
      prevEl: ".swiper-button-prev-unique",
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".slider__pagination",
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1.2,
        spaceBetween: 10,
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      }
    },
  });
}

// Initialize on DOM load; debounce resize re-init
document.addEventListener("DOMContentLoaded", function () {
  initializeSellingSlider();
});

let sellingSliderResizeTimer;
window.addEventListener("resize", function () {
  clearTimeout(sellingSliderResizeTimer);
  sellingSliderResizeTimer = setTimeout(initializeSellingSlider, 200);
});

// Match heights for various sections
setTimeout(() => {
  CtrUtils.matchHeights(".icon-block");
  // CtrUtils.matchHeights(".work-content");
  CtrUtils.matchHeights(".selling_slider .scientifically_image img");
  CtrUtils.matchHeights(".review_content");
  CtrUtils.matchHeights(".design_content");
}, 100);
setTimeout(() => {
  CtrUtils.matchHeights(".design_content");
}, 500);
setTimeout(() => {
  CtrUtils.matchHeights(".design_content");
}, 1000);

// Optionally, you can add an event listener for window resize
window.addEventListener("resize", () => {
  setTimeout(() => {
    CtrUtils.matchHeights(".icon-block");
    // CtrUtils.matchHeights(".work-content");
    CtrUtils.matchHeights(".selling_slider .scientifically_image img");
    CtrUtils.matchHeights(".review_content");
    CtrUtils.matchHeights(".design_content");
  }, 100);
});

/**
 * Make Judge.me review replies collapsible (FAQ-style).
 * Uses MutationObserver to handle dynamically loaded reviews (incl. "See More").
 */
(function initCollapsibleJudgeMeReplies() {
  const PROCESSED_ATTR = "data-jdgm-collapsible";
  const CHEVRON_SVG =
    '<svg class="jdgm-rev__reply-toggle" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function makeReplyCollapsible(reply) {
    if (reply.hasAttribute(PROCESSED_ATTR)) return;
    reply.setAttribute(PROCESSED_ATTR, "1");

    const header = reply.querySelector(".jdgm-rev__replier-wrapper");
    const content = reply.querySelector(".jdgm-rev__reply-content");
    if (!header || !content) return;

    reply.classList.add("jdgm-rev__reply--collapsible");
    header.insertAdjacentHTML("beforeend", CHEVRON_SVG);

    header.addEventListener("click", function () {
      reply.classList.toggle("jdgm-rev__reply--expanded");
    });
  }

  function processReplies(container) {
    if (!container) return;
    container.querySelectorAll(".jdgm-rev__reply").forEach(makeReplyCollapsible);
  }

  var observerAttached = false;

  function init() {
    var container = document.getElementById("judgeme_product_reviews");
    if (!container) return;

    processReplies(container);

    if (!observerAttached) {
      observerAttached = true;
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.addedNodes.length) {
            for (var j = 0; j < m.addedNodes.length; j++) {
              var node = m.addedNodes[j];
              if (node.nodeType === 1) {
                if (node.classList && node.classList.contains("jdgm-rev__reply")) {
                  makeReplyCollapsible(node);
                } else {
                  var replies = node.querySelectorAll ? node.querySelectorAll(".jdgm-rev__reply") : [];
                  for (var k = 0; k < replies.length; k++) makeReplyCollapsible(replies[k]);
                }
              }
            }
          }
        }
      });
      observer.observe(container, { childList: true, subtree: true });
    }
  }

  document.addEventListener("DOMContentLoaded", init);

  [100, 300, 600, 1000, 2000, 3000].forEach(function (ms) {
    setTimeout(init, ms);
  });
})();